module.exports = __webpack_public_path__ + "static/lexus-89e8d53165cb53861ee8eb7861e6505c.jpg";